import { render, staticRenderFns } from "./AiMarkdownInline.vue?vue&type=template&id=3b21896a&scoped=true"
import script from "./AiMarkdownInline.vue?vue&type=script&lang=js"
export * from "./AiMarkdownInline.vue?vue&type=script&lang=js"
import style0 from "./AiMarkdownInline.vue?vue&type=style&index=0&id=3b21896a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21896a",
  null
  
)

export default component.exports